import React from "react";
import swal from "sweetalert";
import { useFieldArray, useForm } from "react-hook-form";
import SubjectForm from "../../components/Subject/SubjectForm";
import Container from "../../components/Container/Container";
import { API } from "../../constants/env";
function AddUser() {
  const [data, setData] = React.useState({});

  const { register, handleSubmit, errors, reset, control } = useForm();
  const { fields, append, remove } = useFieldArray({
    name: "objects",
    control,
  });
  const onSubmit = (data) => {
    data.unit = data.unit?.value;
    if (data.objects) data.objects = data.objects.map((obj) => obj.object);
    data.level = data.level?.map((elem) => elem.value);
    console.log(data);

    fetch(API.subjects.create, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.error) {
          return swal("Error", response.message, "error");
        }
        return swal(
          "Good job!",
          `La Matière ${response.name} est ajoutée"`,
          "success"
        );
      })
      .catch((e) => {
        return swal("Error", e.message, "error");
      });
  };
  return (
    <Container
      name="Ajouter une matière"
      back={true}
      backRoute="/subjects"
      submit={true}
    >
      <SubjectForm
        registerRequired={register({ required: true })}
        register={register()}
        errors={errors}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        reset={reset}
        control={control}
        data={data}
        remove={remove}
        append={append}
        fields={fields}
      />
    </Container>
  );
}

export default AddUser;
